/**
 * Centralized admin configuration for frontend
 * Single source of truth for admin emails
 */

// Allowed admin emails - single source of truth
export const ALLOWED_ADMIN_EMAILS = new Set(["akhuda@gmail.com"]);

/**
 * Check if an email is an allowed admin email
 */
export function isAllowedAdminEmail(email: string | null | undefined): boolean {
  return !!email && ALLOWED_ADMIN_EMAILS.has(email);
}
